import { render, staticRenderFns } from "./MobileApprovalReference.vue?vue&type=template&id=6f55f890&scoped=true&"
import script from "./MobileApprovalReference.vue?vue&type=script&lang=js&"
export * from "./MobileApprovalReference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f55f890",
  null
  
)

export default component.exports